module.exports = __webpack_public_path__ + "467e4751ac10a2812c8ecb2d78961adf.ttf";